import { useContext } from 'react'

import { PageLoggerContext } from './PageLoggerContext'

export const usePageLogger = () => {
  const pageLogger = useContext(PageLoggerContext)
  if (!pageLogger) {
    throw new Error('You must render this element inside a <PageLoggerProvider> element')
  }
  return pageLogger
}
